<div class="container">
    <div class="d-flex justify-content-end">
        <img src="../../../../assets/img/close.svg" alt="" style="cursor: pointer;" (click)="close_popup()">
    </div>
    <div class="d-flex justify-content-center"><img src="../../../../assets/img/locationn.svg" alt=""></div>
    <div class="d-flex justify-content-center" style="margin-top: 10px;">
        <div class="location-text">Location Permission is Off</div>
    </div>
    <div class="d-flex justify-content-center">
        <div class="set">Set your location to start find</div>
    </div>
    <div class="d-flex justify-content-center">
        <div class="resto">restaurants near you</div>
    </div>
    <div>
        <button class="btn-grant" (click)="grantLocation()">Grant</button>
    </div>
    <div class="hr-line">&nbsp;</div>

    <div class="d-flex marg-t" style="padding-bottom: 10px;" (click)="showLocationPage()">
        <div class="d-flex" (click)="showLocationPage()">
            <div class="" (click)="showLocationPage()">
                <img src="../../../../assets/img/SearchIcon.svg" alt="">
            </div>
            <div>
                <button class="btn-location">Enter your Location</button>
            </div>
        </div>
        <div>
            <img src="../../../../assets/img/right-icons.svg" alt="" style="width: 8px;" (click)="showLocationPage()">
        </div>
    </div>
</div>

<style>
    ::ng-deep.mat-bottom-sheet-container-xlarge {
        min-width: 380px;
        max-width: 380px;
    }

    ::ng-deep.mat-bottom-sheet-container-large {
        min-width: 380px;
        max-width: 380px;
    }

    ::ng-deep.mat-bottom-sheet-container {
        padding: 8px 16px;
        box-sizing: border-box;
        display: block;
        outline: 0;
        overflow: auto;
        border-top-left-radius: 16px !important;
        border-top-right-radius: 16px !important;
    }

    .location-text {
        font-size: 18px;
        line-height: 23px;
        letter-spacing: 0.4px;
        color: #3C3C3C;
        font-weight: 500;
    }

    .set {
        margin-top: 6px;
        color: #4E4E4E;
        font-family: 14px;
        line-height: 19px;
        font-family: 'Roboto';
    }

    .resto {
        color: #4E4E4E;
        font-family: 14px;
        line-height: 19px;
        font-family: 'Roboto';
    }

    .btn-grant {
        color: #ffff;
        background: transparent linear-gradient(264deg, #56AB51 0%, #2FB9E3 100%) 0% 0% no-repeat padding-box;
        border: none;
        width: 100%;
        font-weight: 600;
        height: 40px;
        border-radius: 8px;
        font-size: 18px;
        letter-spacing: 1.5px;
        display: flex;
        justify-content: center;
        margin-top: 15px;
        padding-top: 9px;
    }

    .hr-line {
        border-bottom: 1px solid #00000029;
    }

    .btn-location {
        border: none;
        background: transparent;
        width: 100%;
        font-size: 13px;
        line-height: 18px;
        color: #707070;
        font-family: 'Roboto';
        margin-left: 15px;
    }

    .marg-t {
        margin-top: 10px;
        justify-content: space-between;
    }
</style>